/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionType from './actionTypes';
import * as Constants from '../../../../../SharedModules/AppConstants';

const initialState = {
  selected_type: Constants.DRUG_FAMILY_ID,
  selected_search_type: Constants.Name,
  error_msg: [],
  popup_table_data: [],
  left_table_data: [],
  right_table_data: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SELECTION_TYPE_OPTIONS:
      return { ...state, selection_list: action.payload };
    case actionType.SELECTED_TYPE:
      return { ...state, selected_type: action.payload };
    case actionType.SELECTED_SEARCH_TYPE:
      return { ...state, selected_search_type: action.payload };
    case actionType.TABLE_DATA:
      return { ...state, table_data: [...action.payload] };
    case actionType.POPUP_TABLE_DATA:
      return { ...state, popup_table_data: [...action.payload] };
    case actionType.POPUP_FLAG:
      return { ...state, popup_flag: action.payload };
    case actionType.ERROR_MSGS:
      return { ...state, error_msg: action.payload };
    case actionType.SEARCH_LEFT_TABLE_DATA:
      return { ...state, left_table_data: action.payload };
    case actionType.RIGHT_TABLE_DATA:
      return { ...state, right_table_data: action.payload };
    case actionType.NAVIGATE_DETAILS:
      return { ...state, navigate_details: action.payload };
    case actionType.NDC_DATA:
      return { ...state, ndc_data: action.payload };
    case actionType.DRUG_FAMILY_DAETAILS:
      return { ...state, drug_family_details: action.payload };
    case actionType.NDC_NAME:
      return { ...state, ndc_name: action.payload };
    case actionType.RESET_DRUG_FAMILY_DATA:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
